













import { Component, Mixins, Watch } from "vue-property-decorator";

// Mixins
import CProdInjectorMixin from "@/mixins/cProdInjectorMixin";
import BillableEntitiesInjectorMixin from "@/mixins/billableEntitiesInjectorMixin";

// Types
import { IContract } from "@/models/contracts";

@Component({
  components: {
    "billable-entities": () =>
      import("@/components/app/global/client/billableEntities.vue")
  }
})
export default class CProdBillingAddressForm extends Mixins(
  CProdInjectorMixin,
  BillableEntitiesInjectorMixin
) {
  // Data

  public isProcessing = false;
  public form = {} as Pick<IContract, "company_id" | "address_id">;

  // Lifecycle methods

  public async created() {
    this.initialiseForm();
  }

  // Methods

  public initialiseForm() {
    this.form = this.initForm();
  }

  public initForm() {
    return this.$_.pick(this.cProdData.contract, ["company_id", "address_id"]);
  }

  public async submit() {
    try {
      this.isProcessing = true;
      await this.$cProdMethods.changeAddressOrCompany(this.form);
      await this.$cProdMethods.reloadData();
      this.initialiseForm();
      this.$store.dispatch("toast/show", {
        message: this.$t("_sentence.cprod.entity_successfully_updated", {
          entity: this.$_.upperFirst(this.cProdData.entity)
        })
      });
    } catch (error) {
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    } finally {
      this.isProcessing = false;
    }
  }

  public revertToInitialState() {
    this.initialiseForm();
  }

  public onAddressSelect(address) {
    this.$set(this.form, "address_id", address.id);
    this.$set(this.form, "company_id", null);
  }

  public onCompanySelect(company) {
    if (company.id === this.form.company_id) return;

    this.$set(this.form, "company_id", company.id);
    this.$set(this.form, "address_id", company.address_id);
  }

  // Computed

  public get formIsChanged() {
    return !this.$_.isEqual(this.form, this.initForm());
  }

  public get isDisabled() {
    return !this.cProdData.canChangeBillingEntity;
  }

  public get clientId() {
    return this.cProdData?.contract?.client_id;
  }

  // Watchers

  @Watch("formIsChanged")
  public onIsEnabledChange() {
    this.$emit("isEnabled", this.formIsChanged);
  }

  @Watch("isProcessing")
  public onIsProcessingChange() {
    this.$emit("isProcessing", this.isProcessing);
  }
}
